import UserAPI from "src/api/interfaces/user";

export const FAILED_FETCH_TRIAL_DATA = "FAILED_FETCH_TRIAL_DATA,";
export const FETCH_TRIAL_DATA = "FETCH_TRIAL_DATA,";
export const SUCCESS_FETCH_TRIAL_DATA = "SUCCESS_FETCH_TRIAL_DATA,";

export const fetchTrial = () => async (dispatch, getState) => {
  if (getState().commonTrial.loadingTrial) return;

  dispatch({ type: FETCH_TRIAL_DATA });

  try {
    const response = await UserAPI.getTrialInfo();
    dispatch({ type: SUCCESS_FETCH_TRIAL_DATA, payload: response });
  } catch (errors) {
    dispatch({ type: FAILED_FETCH_TRIAL_DATA, payload: errors });
  }
};
